module.exports = __webpack_public_path__ + "static/media/twitter.8628d9c4.png";